module.exports = __webpack_public_path__ + "static/media/31JFA11.48dcb986.jpg";